import React, { useState } from "react";
import * as HTTPServices from "../api/HTTPServices";

const UserContext = React.createContext();
const UserContextSetState = React.createContext();

function UserProvider({ children }) {
  const [user, setUser] = useState("");
  return (
    <UserContext.Provider value={user}>
      <UserContextSetState.Provider value={setUser}>
        {children}
      </UserContextSetState.Provider>
    </UserContext.Provider>
  );
}

function useUserState() {
  return React.useContext(UserContext);
}

function useUserSetState() {
  return React.useContext(UserContextSetState);
}

function useUserActions() {
  const updateUser = useUserSetState();
  let lang = localStorage.getItem("language");
  if (lang === null) {
    lang = "en";
  }

  const setUser = () => {
    const RequestService = HTTPServices.getMethod(
      "get_start",
      `lang=${lang}`,
      "true"
    );
    RequestService.then(function (response) {
      if (response) {
        updateUser(response);

        window.localStorage.setItem(
          "medical-history",
          response.user_login.mdical_history_status
        );
        window.localStorage.setItem(
          "doctor-info",
          response.user_login.doctor_info_status
        );
      }
    });
  };
  return { setUser };
}

export { useUserState, useUserSetState, useUserActions };
export default UserProvider;
